import React from 'react';
import './childrenForm.css';
import { useDispatch, useSelector } from "react-redux";
import { setChildrenFormAction, setChildFormAction } from "../../redux/rootReducer";
import { CHILDREN_FORM_INITIAL } from "../../redux/initialStateConstant";
import { getChildByIdSagaAction, removeChildSagaAction } from "../../redux/sagaActions";

const ChildrenForm = () => {
    const dispatch = useDispatch();
    const children_form = useSelector(state => state.children_form);
    const child_form = useSelector(state => state.child_form);

    return (
        <div className="form form--children">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close" onClick={ () => dispatch(setChildrenFormAction(CHILDREN_FORM_INITIAL)) }/>
                        <div className="form__title">Дети</div>
                    </div>
                    <div className="form__field">
                        <div className="table">
                            <div className="table__row table__row--children table__row--header">
                                <div className="table__cell table__cell--left">Имя</div>
                                <div className="table__cell">Дата рождения</div>
                                <div className="table__cell"/>
                            </div>
                            {
                                children_form.children.map(elem => {
                                    return (
                                        <div className="table__row table__row--children" key={ elem.id }>
                                            <div className="table__cell table__cell--left">{ elem.name }</div>
                                            <div className="table__cell">{ elem.birthday }</div>
                                            <div className="table__cell table__cell--no-overflow">
                                                <div className="controls controls--children">
                                                    <div className="control control--edit"
                                                        onClick={ () => {
                                                            dispatch(getChildByIdSagaAction({
                                                                child_id: elem.id
                                                            }));
                                                        } }
                                                    />
                                                    <div className="control control--remove"
                                                        onClick={ () => {
                                                            if (!window.confirm('Вы действительно хотите удалить запись?')) return;

                                                            dispatch(removeChildSagaAction({
                                                                child_id: elem.id
                                                            }));
                                                        } }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                dispatch(setChildFormAction({
                                    ...child_form,
                                    open: true
                                }));
                            } }
                        >Добавить ребёнка</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChildrenForm;